import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SelectItem } from "primeng/api";
import { PoliticaPlanteamientoPolitica } from "../../../../_models/politica-planteamiento-politica";
import { CentralizadaPoliticas } from "../../../../_models/gestor-politicas";
import { PlantillaParametro } from "../../../../_models/plantilla-parametro";
import { NavService } from "../../../../_services/_nav.service";
import { forkJoin } from "rxjs";
import { PlantillaParametroService } from "../../../../_services/plantilla-parametro.service";
import { ListaService } from "../../../../_services/lista.service";
import { PoliticasPlanteamientosPoliticasService } from "../../../../_services/politicas-planteamientos-politicas.service";
import { PoliticaService } from "../../../../_services/politica.service";
import { PoliticaSimulador } from "../../../../_models/politica-simulador";
import { ListaItem } from "../../../../_models/lista-item";
import { CalendarioPropiedades } from "../../../../_models/calendario-propiedades";
import { sleep } from "../../../../utils/utilidades";
import { ConfirmationService } from 'primeng/api';
import {CodigosPoliticas, EstadoConyuge, ParametrosPoliticas, TipoActividadEconomica, Vinculaciones} from '../../../../_enums/enum';
import { TipoOcupacionConfiguracionService } from '../../../../_services/tipo-ocupacion-configuracion.service';
import { TipoOcupacionConfiguracion } from '../../../../_models/tipo-ocupacion-configuracion';
import { ConstanteService } from '../../../../_services/constante.service';
import { Constante } from '../../../../_models/constante';
import { ActividadEconomicaService } from '../../../../_services/actividad-economica.service';
import {PerfilRiesgoService} from '../../../../_services/perfil-riesgo.service';
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-politica-planteamiento-politica",
  templateUrl: "./politica-planteamiento-politica.component.html",
  styleUrls: ["./politica-planteamiento-politica.component.css"],
})
export class PoliticaPlanteamientoPoliticaComponent implements OnInit {
  @Input() centralizadaPoliticas: CentralizadaPoliticas;
  @Input() esDetalle: boolean = false;
  @Output()
  actualizarPoliticaPlanteamientoPolitica: EventEmitter<CentralizadaPoliticas> = new EventEmitter<CentralizadaPoliticas>();
  @Output()
  planteamientosEditado: EventEmitter<boolean> = new EventEmitter<boolean>();

  carInformacionInicial = true;
  submitted = false;
  submittedModalVinculaciones = false;
  submittedModalComprobarPolitica = false;
  formulario: FormGroup;
  formularioComprobarPolitica: FormGroup;
  formularioVinculaciones: FormGroup;
  columnas: any[] = [];
  columnas2: any[] = [];
  lisParametros: PlantillaParametro[] = [];
  lisParametrosAgregados: PlantillaParametro[] = [];
  lisValoresProbar: any[] = [];
  listaVinculaciones: SelectItem[] = [];
  listaCondiciones: SelectItem[] = [];
  lisFrecuenciaProductoTodos: ListaItem[] = [];
  listaFrecuenciaProducto: SelectItem[] = [];
  listaFrecuenciaProductoCodigo: SelectItem[] = [];
  listaTiposCondicionalesTodos: ListaItem[] = [];
  listaTiposCondicionales: SelectItem[] = [];
  listaTiposVinculaciones: SelectItem[] = [];
  listaTiposVinculacionesCruzada: SelectItem[] = [];
  listaTiposVinculacionesCruzadaSinTitular: SelectItem[] = [];
  campoFormulario;
  carTabla = false;
  mostrarDialogoVinculaciones = false;
  mostrarDialogoComprobarPolitica = false;
  parametro;
  cumplePolitica = null;
  carFormularioComprobarPolitica = false;
  comprobandoPolitica = false;
  calPropiedades: CalendarioPropiedades = new CalendarioPropiedades();
  ordenar: boolean;
  cantidadPatron: any[] = [];
  parametrosPoliticas = ParametrosPoliticas;
  listTipoOcupaciones: SelectItem[] = [];
  listTipoOcupacionesTodos: ListaItem[] = [];
  listActividadEconomica: SelectItem[] = [];
  listActividadEconomicaTodos: ListaItem[] = [];
  listaAdmOcupaciones: SelectItem[] = [];
  listaTiposDocumentos: SelectItem[] = [];
  listaAdmOcupacionesTodos: TipoOcupacionConfiguracion[] = [];
  listaTiposGarantias: SelectItem[] = [];
  codigoNum: Constante;
  codigoVer: Constante;
  codigoOcupEmp: Constante;
  codigoOcupPen: Constante;
  codigoUltiVect: Constante;
  codigoSalario: Constante;
  codigoAct: Constante;
  codigoTidove: Constante;
  constanteNivrem: Constante;
  constanteMeinco: Constante;
  constanteParacc: Constante;
  constantePattec: Constante;
  maxLength: number;

  tipoActividad = TipoActividadEconomica;

  listPerfilesRiesgos: SelectItem[] = [];
  listaPeriflesRiesgoTodos: ListaItem[] = [];
  aplica: boolean;

  saldoCapital: number;
  montoDesembolsado: number;
  porcetajeCancelado: number;
  cuotas: number;
  frecuencia: string;
  mesesCuotas: any;
  listEstadoDocumento: SelectItem[] = [];
  listaEstadosCiviles: SelectItem[] = [];
  listaEstadosUnidadFamiliar: SelectItem[] = [];
  resultadoValidacionFirmasConyuges: any;
  estadoConyuge = EstadoConyuge;
  fechaActual: Date = new Date();
  minFechaDocumento = new Date();
  ranFechaNum = 120;
  inputsCreditosAntiguos: { value: string, tipoVinculacion: string }[] = [];
  inputsCreditosNuevos: { value: string, tipoVinculacion: string }[] = [];
  fechaDeHoy: Date;
  diferenciaMeses : number | null = null;
  banVentaCruzada: boolean = false;
  edadTerceroMeses : number | null = null;
  vinculacion1: any;
  vinculacion2: any;
  vinculacionesIguales: boolean = false;
  vinculacionesRespaldos: boolean = false;
  errorIndicesAntiguos: number[] = [];
  errorIndicesNuevos: number[] = [];

  porcentajeCobertura: number = 0;

  constructor(
    private navService: NavService,
    private fb: FormBuilder,
    private parametersService: PlantillaParametroService,
    private listaService: ListaService,
    private politicasPlanteamientosPoliticasService: PoliticasPlanteamientosPoliticasService,
    private politicaService: PoliticaService,
    private conServicio: ConfirmationService,
    private tipOcupacionConfiguracionService: TipoOcupacionConfiguracionService,
    private constServicio: ConstanteService,
    private actividadEconomicaService: ActividadEconomicaService,
    private perfilServicio: PerfilRiesgoService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.setearColumnas();
    this.minFechaDocumento.setFullYear( this.fechaActual.getFullYear() - this.ranFechaNum );
    console.log(this.minFechaDocumento);
    this.cargaInicial();
  }

  cargaInicial() {
    this.fechaDeHoy = new Date();
    this.calPropiedades.actualizarRango(80);
    /* llenar lista de vinculaciones */
    this.centralizadaPoliticas.listaVinculaciones.map((x) => {
      this.listaTiposVinculaciones.push({ label: x.nombre, value: x.codigo });
    });

    forkJoin(
      this.parametersService.getAllEnabled(),
      this.listaService.getMasterDetails("ListasTiposVinculaciones"),
      this.listaService.getMasterDetails("ListasFrecuenciasProductos"),
      this.listaService.getMasterDetails("ListasCondiciones"),
      this.listaService.getMasterDetails("ListasTiposCondicionales"),
      this.listaService.getMasterDetails("ListasTiposOcupaciones"),
      this.listaService.getMasterDetails("ListasTiposDocumentos"),
      this.listaService.getMasterDetails("ListasEstadosCiviles"),
      this.listaService.getMasterDetails("ListasEstadosUnidadFamiliar"),
      this.listaService.getMasterDetails("ListasTiposVinculaciones"),
      this.tipOcupacionConfiguracionService.listadoSecuenciaHabilitados(),
      this.actividadEconomicaService.listarPorTipo(this.tipoActividad.CLASE),
      this.constServicio.getByCode('NUMVER'),
      this.constServicio.getByCode('VEREES'),
      this.constServicio.getByCode('OCUEMP'),
      this.constServicio.getByCode('OCUPEN'),
      this.constServicio.getByCode('NUVEC2'),
      this.constServicio.getByCode('CSMMLV'),
      this.perfilServicio.listadoHabilitados(),
      this.constServicio.getByCode('TIDOVE'),
      this.constServicio.getByCode('NIVREM'),
      this.constServicio.getByCode('MEINCO'),
      this.listaService.getMasterDetails("ListasTiposGarantias"),
      this.constServicio.getByCode('PARACC'),
      this.constServicio.getByCode('PATTEC'),

    ).subscribe(
      async ([
        lisParametros,
        listasTiposVinculaciones,
        listasFrecuenciasProductos,
        listaCondiciones,
        listaTiposCondicionales,
        listaTiposOcupaciones,
        listaTiposDocumentos,
        listaEstadosCiviles,
        listaEstadosUnidadFamiliar,
        listaTiposVinculaciones,
        listaAdmOcupaciones,
        listaActividadEconomica,
        codigoNum, // NUMVER
        codigoVer, // VEREES
        codigoEmpleado,
        codigoPensionado,
        codigoUltimoVector, // NUVEC2
        salario,
        perfil,
        tidove,
        nivrem,
        meinco,
        listaTiposGarantias,
        paracc,
        pattec
        /* politicasPlanteamientosPoliticas, */
      ]) => {
        lisParametros.map((x) => {
          if (x.indicadorPolitica) {
            this.lisParametros.push(x);
          }
        });
        listasTiposVinculaciones.map((x) => {
          this.listaVinculaciones.push({ label: x.nombre, value: x.idLista });
        });
        listaCondiciones.map((x) => {
          this.listaCondiciones.push({ label: x.nombre, value: x.idLista });
        });
        this.listaTiposCondicionalesTodos = listaTiposCondicionales;
        listaTiposCondicionales.map((x) => {
          this.listaTiposCondicionales.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        this.lisFrecuenciaProductoTodos = listasFrecuenciasProductos;
        listasFrecuenciasProductos.forEach( s => {
          if ( s.indicadorHabilitado ) {
            this.listaFrecuenciaProducto.push( {
              label: s.nombre,
              value: s.idLista
            } );
            this.listaFrecuenciaProductoCodigo.push( {
              label: s.nombre,
              value: s.codigo.substring(1)
            } );
          }
        } );
        this.listTipoOcupacionesTodos = listaTiposOcupaciones.filter( x => x.indicadorHabilitado );
        listaTiposOcupaciones.forEach( v => {
          this.listTipoOcupaciones.push({
            label: v.nombre,
            value: v.idLista,
          });
        });

        this.listaAdmOcupacionesTodos = listaAdmOcupaciones;
        listaAdmOcupaciones.forEach( v => {
          this.listaAdmOcupaciones.push({label: v.nombreTipoOcupacion, value: v.idTipoOcupacionConfiguracion});
        });
        this.listActividadEconomicaTodos = listaActividadEconomica as any;
        listaActividadEconomica.forEach( v => {
          this.listActividadEconomica.push({label: v.actividadEconomica, value: v.idActividadEconomica});
        });
        this.listaPeriflesRiesgoTodos = perfil as any;
        perfil.forEach( y => {
          this.listPerfilesRiesgos.push({label: `${y.codigo}-${y.nombreRiesgo}`, value: y.idPerfilRiesgo });
        });
        listaTiposDocumentos.forEach( d => {
          this.listaTiposDocumentos.push({label: d.nombre, value: d.codigo});
        })
        listaEstadosCiviles.forEach( d => {
          this.listaEstadosCiviles.push({label: d.nombre, value: d.codigo});
        })
        listaEstadosUnidadFamiliar.forEach( d => {
          this.listaEstadosUnidadFamiliar.push({label: d.nombre, value: d.codigo});
        })
        listaTiposVinculaciones.forEach( d => {
          this.listaTiposVinculacionesCruzada.push({label: d.nombre, value: d.codigo});
          if (d.codigo !== 'TITULAR') {
            this.listaTiposVinculacionesCruzadaSinTitular.push({label: d.nombre, value: d.codigo});
          }
        });
        this.listEstadoDocumento.push({label: `Vigente`, value: 1 }, {label: `No Vigente`, value: 0 });
        this.codigoNum = codigoNum;
        this.codigoVer = codigoVer;
        this.codigoOcupEmp = codigoEmpleado;
        this.codigoOcupPen = codigoPensionado;
        this.codigoUltiVect = codigoUltimoVector;
        this.codigoSalario = salario;
        this.codigoTidove = tidove;
        this.constanteNivrem = nivrem;
        this.constanteMeinco = meinco;
        this.constanteParacc = paracc;
        this.constantePattec = pattec;
        listaTiposGarantias.forEach(g => {
          this.listaTiposGarantias.push({ label: g.nombre, value: g.codigo });
        });
        await this.cargarPlanteamientos();
        this.cargarFormulario();
        this.carInformacionInicial = false;
      }
    );
  }

  /* cargar los planteamientos politicas */
  async cargarPlanteamientos() {
    if (
      this.centralizadaPoliticas &&
      this.centralizadaPoliticas.politica &&
      this.centralizadaPoliticas.politica.idPolitica
    ) {
      this.politicasPlanteamientosPoliticasService
        .listadoPorPolitica(this.centralizadaPoliticas.politica.idPolitica)
        .subscribe(
          (res) => {
            /* limpiar listado de politicasPlanteamientosPoliticas y dejarlo actulizado con los registros en base */
            this.centralizadaPoliticas.politicasPlanteamientosPoliticas = [];
            this.centralizadaPoliticas.politicasPlanteamientosPoliticas = res.filter( r => r.indicadorHabilitado);

            if (res) {
              /* agregar idLocal para el orden en la tabla */
              this.centralizadaPoliticas.politicasPlanteamientosPoliticas.sort( (a, b) => {
                if (a.orden < b.orden) {
                  return -1;
                }
                if (a.orden > b.orden) {
                  return 1;
                }
                return 0;
              });
              this.ordenarListaPoliticas();
              //this.validarCondicional();
            }
            /* acutualizar el objeto centralizadaPoliticas */
            this.actualizarPoliticaPlanteamientoPolitica.emit(
              this.centralizadaPoliticas
            );
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  obtenerFrecuencia( idFrecuencia: string ) {
    return this.lisFrecuenciaProductoTodos.find( x => x.idLista ===  idFrecuencia );
  }

  actualizarMaxLength(codigoParametro: string) {
    if (this.fCoontrolsFCP[codigoParametro].value < 0 ) {
      this.maxLength = codigoParametro === this.parametrosPoliticas.PUNTAJESCORE ? 7 : 13;
    } else {
      this.maxLength = codigoParametro === this.parametrosPoliticas.PUNTAJESCORE ? 6 : 12;
    }
  }

  /* verificar que parametros estan agregados a los plantemientos para agregar el campo al formulario de comprobar politica */
  agregarCamposFormularioSimulador() {
    this.lisParametrosAgregados = [];
    this.lisParametros.map((x) => {
      if (
        this.centralizadaPoliticas.politicasPlanteamientosPoliticas.find(
          (s) =>
            (s.variable1.includes('{{' + x.codigoParametro + '(') ||
              s.variable2.includes('{{' + x.codigoParametro + '(')) &&
            s.indicadorHabilitado
        ) &&
        !this.lisParametrosAgregados.find(
          (e) => e.codigoParametro === x.codigoParametro
        )
      ) {
        this.lisParametrosAgregados.push(x);
      }
    });
  }

  /* setear columnas */
  setearColumnas() {
    /* columnas del datatable de parametros */
    this.columnas = [
      {
        field: "codigoParametro",
        header: this.navService.buscarMensaje("PLANTILLA.LBL_CODIGO"),
        sort: false,
      },
      {
        field: "parametro",
        header: this.navService.buscarMensaje("PLANTILLA.LBL_NOMBRE"),
        sort: true,
      },
      {
        field: "agregar",
        header: this.navService.buscarMensaje("LBL_AGREGAR"),
        sort: false,
      },
    ];

    /* columnas del datatable de PoliticaPlanteamientoPolitica */
    this.columnas2 = [
      {
        field: "orden",
        header: this.navService.buscarMensaje("POLITICAS.LBL_ORDEN"),
        sort: false,
      },
      {
        field: "variable1",
        header: this.navService.buscarMensaje("POLITICAS.LBL_VARIABLE1"),
        sort: false,
      },
      {
        field: "operacion",
        header: this.navService.buscarMensaje("POLITICAS.LBL_OPERACION"),
        sort: false,
      },
      {
        field: "variable2",
        header: this.navService.buscarMensaje("POLITICAS.LBL_VARIABLE2"),
        sort: false,
      },
      {
        field: "condicional",
        header: this.navService.buscarMensaje("POLITICAS.LBL_CONDICIONAL"),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  /* inicializar formulario */
  cargarFormulario() {
    this.formulario = this.fb.group({
      orden: [null],
      variable1: [null, [Validators.required]],
      idOperacion: [null, [Validators.required]],
      variable2: [null, [Validators.required]],
      idCondicional: [null, [Validators.required]]
    });

    this.formularioVinculaciones = this.fb.group({
      codigosVinculaciones: [null, [Validators.required]],
    });
  }

  /* inicializar formulario comporbar politica */
  cargarFormularioComprobarPolitica() {
    this.carFormularioComprobarPolitica = true;
    this.formularioComprobarPolitica = null;
    this.formularioComprobarPolitica = this.fb.group({});
    this.formularioComprobarPolitica.addControl('idPerfilRiesgo',
      this.fb.control(null, this.centralizadaPoliticas.politica.indicadorPerfilRiesgo ? [Validators.required] : [] )
    );
    let conmon = false;
    this.lisParametrosAgregados.map((parametroAgregado) => {
      if (parametroAgregado.codigoParametro === this.parametrosPoliticas.CONNOM) {
        conmon = true;
      }
      this.formularioComprobarPolitica.addControl(
        parametroAgregado.codigoParametro,
        this.fb.control(
          parametroAgregado.codigoParametro === this.parametrosPoliticas.FECHAACT ? new Date() : parametroAgregado.codigoParametro === this.parametrosPoliticas.DIA ? 1 : null,
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.MES &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.ANIO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.SALARIO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.QUANTOVALORMEDIO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.NOVEDADRETIRO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANSOCIOSARLAFT &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANSOCIOSARLAFTJURIDICO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANSOCIOSLISTASRES &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANSOCIOSNOTAINTERNA &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANLISTASNEGRASDOCUMENTOS &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANLISTASNEGRASTELEFONOS &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANLISTASNEGRASCORREOS &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.FECHAACT &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.DIA &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.TALANLISTASNEGRASCORREOS &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.FIRPAG &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.CONNOM &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.ULTOCU &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.ULTACTECO &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.GARIDON  &&
          parametroAgregado.codigoParametro !== this.parametrosPoliticas.PATRITECN
          ? [Validators.required] : [])
      );
    });
    this.formularioComprobarPolitica.addControl('estadoInicial', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('estadoFinal', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('conyuge', this.fb.control(this.estadoConyuge.NOAPLICA,[] ));
    this.formularioComprobarPolitica.addControl('estadoConyuge', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('tipoVinculacion0', this.fb.control('',[] ));
    this.formularioComprobarPolitica.addControl('tipoVinculacionNuevo0', this.fb.control('',[] ));
    this.formularioComprobarPolitica.addControl('numeroCedula', this.fb.control('',[] ));
    this.formularioComprobarPolitica.addControl('edadTercero', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('vinculacionRespaldo', this.fb.control(0,[] ));
    this.formularioComprobarPolitica.addControl('montoCobertura', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('montoSolicitud', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('nivelRiesgoEmpleador', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('ocupacion', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('vector', this.fb.control(null,[] ));
    this.formularioComprobarPolitica.addControl('ocupacionAnterior', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('ocupacionActual', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('actividadEconomicaAnterior', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('actividadEconomicaActual', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('tipoGarantiaGaridon', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('valorEndeudamiento', this.fb.control(null, []));
    this.formularioComprobarPolitica.addControl('porcentajeParticipacion', this.fb.control(null, []));
    if ( conmon ) {
      this.formularioComprobarPolitica.addControl('datosSolicitud', this.fb.control(null,[Validators.required] ));
      this.formularioComprobarPolitica.addControl('datosConsultas', this.fb.control(null,[Validators.required] ));
    }
    this.carFormularioComprobarPolitica = false;
  }

  /* validar el condicional agregado para que en los siguientes registros que se agreguen solo tenga ese valor */
  validarCondicional() {
    if (
      this.centralizadaPoliticas.politicasPlanteamientosPoliticas.length > 0
    ) {
      this.listaTiposCondicionales.forEach((item, index) => {
        if (
          item.value !==
          this.centralizadaPoliticas.politicasPlanteamientosPoliticas[0]
            .idCondicional
        ) {
          this.listaTiposCondicionales.splice(index, 1);
        }
      });
    }
  }

  /* abrir modal para seleccionar las vinculacion que se le van a aplicar al parametro */
  abrirModalVinculaciones(parametro: string = "") {
    this.parametro = parametro;
    this.mostrarDialogoVinculaciones = true;
  }

  /* cerrar modal para seleccionar las vinculacion que se le van a aplicar al parametro */
  cerrarModalVinculaciones() {
    this.parametro = null;
    this.formularioVinculaciones.reset();
    this.submittedModalVinculaciones = false;
    this.mostrarDialogoVinculaciones = false;
  }

  /* agregar parametro al campo respectivo */
  agregarParametro() {
    this.submittedModalVinculaciones = true;
    if (this.formularioVinculaciones.valid) {
      /* crear txt de las vinculaciones seleccionadas */
      let vinculaciones;
      this.fCoontrolsVinculaciones.codigosVinculaciones.value.map((x) => {
        vinculaciones = vinculaciones
          ? vinculaciones +
            "," +
            this.listaTiposVinculaciones.find((e) => e.value === x).value
          : this.listaTiposVinculaciones.find((e) => e.value === x).value;
      });
      /* seterar valor a los campos correspondientes */
      if (this.campoFormulario === "variable1") {
        const txt = this.f.variable1.value
          ? this.f.variable1.value +
            "{{" +
            this.parametro +
            "(" +
            vinculaciones +
            ")}}"
          : "{{" + this.parametro + "(" + vinculaciones + ")}}";
        this.f.variable1.setValue(txt);
      } else if (this.campoFormulario === "variable2") {
        const txt = this.f.variable2.value
          ? this.f.variable2.value +
            "{{" +
            this.parametro +
            "(" +
            vinculaciones +
            ")}}"
          : "{{" + this.parametro + "(" + vinculaciones + ")}}";
        this.f.variable2.setValue(txt);
      }

      this.cerrarModalVinculaciones();
    }
  }

  /* agregar PoliticaPlanteamientoPolitica al listado */
  async onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      console.log('sksksk')
      console.log(this.formulario.value);
      this.planteamientosEditado.emit(true);
      this.carTabla = true;
      if (this.f.orden.value) {
        /* actulizar */
        this.centralizadaPoliticas.politicasPlanteamientosPoliticas.map((x) => {
          if (x.orden === this.f.orden.value) {
            x.variable1 = this.f.variable1.value;
            x.idOperacion = this.f.idOperacion.value;
            x.operacion = this.listaCondiciones.find(
              (x) => x.value === this.f.idOperacion.value
            ).label;
            x.variable2 = this.f.variable2.value;
            x.idCondicional = this.f.idCondicional.value;
            x.tipoCondicional = this.listaTiposCondicionales.find(
              (x) => x.value === this.f.idCondicional.value
            ).label;
          }
        });
      } else {
        /* crear */
        const politicaPlanteamientoPolitica = {} as PoliticaPlanteamientoPolitica;
          politicaPlanteamientoPolitica.orden =
            this.centralizadaPoliticas.politicasPlanteamientosPoliticas.length ===
            0
              ? 1
              : this.centralizadaPoliticas.politicasPlanteamientosPoliticas
              .length + 1;
        politicaPlanteamientoPolitica.variable1 = this.f.variable1.value;
        politicaPlanteamientoPolitica.idOperacion = this.f.idOperacion.value;
        politicaPlanteamientoPolitica.operacion = this.listaCondiciones.find(
          (politicaPlanteamientoPolitica) =>
            politicaPlanteamientoPolitica.value === this.f.idOperacion.value
        ).label;
        politicaPlanteamientoPolitica.variable2 = this.f.variable2.value;
        politicaPlanteamientoPolitica.idCondicional = this.f.idCondicional.value;
        politicaPlanteamientoPolitica.tipoCondicional = this.listaTiposCondicionales.find(
          (politicaPlanteamientoPolitica) =>
            politicaPlanteamientoPolitica.value === this.f.idCondicional.value
        ).label;
        politicaPlanteamientoPolitica.indicadorHabilitado = true;
        politicaPlanteamientoPolitica.idPolitica = this.centralizadaPoliticas.politica ? this.centralizadaPoliticas.politica.idPolitica : null;
        this.centralizadaPoliticas.politicasPlanteamientosPoliticas.push(
          politicaPlanteamientoPolitica
        );
      }
      //this.validarCondicional();
      this.cargarFormulario();
      this.ordenarListaPoliticas();
      /* notificar acutualizacion del objeto centralizador */
      this.actualizarPoliticaPlanteamientoPolitica.emit(
        this.centralizadaPoliticas
      );
      this.planteamientosEditado.emit(true);
      this.submitted = false;
      await sleep(100);
      this.carTabla = false;
    }
  }

  /* controls del formulario planteamiento politica */
  get f() {
    return this.formulario.controls;
  }

  /* controls del formulario comporbar politica */
  get fCoontrolsFCP() {
    return this.formularioComprobarPolitica.controls;
  }

  /* controls del formulario vinculaciones */
  get fCoontrolsVinculaciones() {
    return this.formularioVinculaciones.controls;
  }

  /* editar  PoliticaPlanteamientoPolitica */
  editarPoliticaPlanteamientoPolitica(row: PoliticaPlanteamientoPolitica) {
    this.f.orden.setValue(row.orden);
    this.f.variable1.setValue(row.variable1);
    this.f.idOperacion.setValue(row.idOperacion);
    this.f.variable2.setValue(row.variable2);
    this.f.idCondicional.setValue(row.idCondicional);

    if (
      this.centralizadaPoliticas.politicasPlanteamientosPoliticas.length === 1
    ) {
      this.listaTiposCondicionales = [];
      this.listaTiposCondicionalesTodos.map((x) => {
        this.listaTiposCondicionales.push({
          label: x.nombre,
          value: x.idLista,
        });
      });
    }
  }

  /* abrir modal para probar la politica */
  abrirModalComprobarPolitica() {
    this.validarAplicaPerfilRiesgo();
    this.agregarCamposFormularioSimulador();
    this.cargarFormularioComprobarPolitica();
    this.inicializarVentaCruzada();
    this.inicializarValores();
    this.mostrarDialogoComprobarPolitica = true;
  }

  inicializarValores () {
    this.edadTerceroMeses = null;
    const validarParametro = !!this.lisParametrosAgregados.find( parametro => parametro.codigoParametro === this.parametrosPoliticas.VINVULACIONRESPALDOS );
    if( validarParametro ) {
      this.fCoontrolsFCP[this.parametrosPoliticas.VINVULACIONRESPALDOS].setValue(0);
      this.fCoontrolsFCP[this.parametrosPoliticas.DIA].setValue(1);
    }
    const validarParametroAsegurabilidad = !!this.lisParametrosAgregados.find( parametro => parametro.codigoParametro === this.parametrosPoliticas.TERCEROASEGURABLE );
    if( validarParametroAsegurabilidad ) {
      this.fCoontrolsFCP[this.parametrosPoliticas.TERCEROASEGURABLE].setValue(0);
    }
  }

  inicializarVentaCruzada() {
    this.inputsCreditosAntiguos = [{ value: '', tipoVinculacion: 'TITULAR' }];
    this.inputsCreditosNuevos= [{ value: '', tipoVinculacion: 'TITULAR' }];
    this.fCoontrolsFCP['tipoVinculacion0'].setValue('TITULAR');
    this.fCoontrolsFCP['tipoVinculacionNuevo0'].setValue('TITULAR');
    this.banVentaCruzada = !!this.lisParametrosAgregados.find( parametro => parametro.codigoParametro === this.parametrosPoliticas.VENTACRUZADA );
  }

  /* cerrar modal para probar la politica */
  cerrarModalComprobarPolitica() {
    // seteo valores null para nuevas politicas de retanqueo
    this.porcetajeCancelado = null;

    // Parametro Meses cuotas pagadas
    this.mesesCuotas = null;
    this.porcentajeCobertura = null;
    this.frecuencia = null;
    this.cuotas = null;

    this.cumplePolitica = null;
    this.formularioComprobarPolitica.reset();
    this.submittedModalComprobarPolitica = false;
    this.mostrarDialogoComprobarPolitica = false;
  }

  /* comprobar la politica usando los valores del modal comprobar politica y los planteamientos agregados */
  comprobarPolitica() {
    this.submittedModalComprobarPolitica = true;
    this.handleButtonClick();
    console.log(this.formularioComprobarPolitica.value);
    let politicaSimulador = {} as PoliticaSimulador;
    politicaSimulador.funciones = this.centralizadaPoliticas.politicasPlanteamientosPoliticas;
    this.lisValoresProbar = [];
    if (this.formularioComprobarPolitica.valid) {
      this.comprobandoPolitica = true;
      this.lisParametrosAgregados.map((parametroAgregado) => {
        let objValorProbar = {} as any;
        objValorProbar.codigo = parametroAgregado.codigoParametro;
        objValorProbar.valor = this.valorParametro(parametroAgregado.codigoParametro);
        this.lisValoresProbar.push(objValorProbar);
      });
      politicaSimulador.parametros = this.lisValoresProbar;
      politicaSimulador.ordenEjecucion = this.centralizadaPoliticas.politica.ordenEjecucion;
      politicaSimulador.politicasPerfilesRiesgos = this.centralizadaPoliticas.listPoliticasPerfilesRiesgos;
      politicaSimulador.idPerfilRiesgo = this.fCoontrolsFCP.idPerfilRiesgo.value;

      this.politicaService.simulador(politicaSimulador).subscribe(
        (res) => {
          this.cumplePolitica = res;
          this.comprobandoPolitica = false;
        },
        (error) => {
          console.log(error);
          this.comprobandoPolitica = false;
        }
      );
    }
  }

  comprobarNombre(){
    if (this.fCoontrolsFCP['datosSolicitud'].value && this.fCoontrolsFCP['datosConsultas'].value ) {
      const v1: string = this.fCoontrolsFCP['datosSolicitud'].value;
      const v2: string = this.fCoontrolsFCP['datosConsultas'].value;
      this.fCoontrolsFCP[this.parametrosPoliticas.CONNOM].setValue(
        v1.toUpperCase() === v2.toUpperCase() ? 1 : 0
      );
    }
  }

  /* funcion para convertir la fecha en milisegundos */
  obtenerMilisegundosFecha(codigoParametro: string) {
    let date: Date = new Date(this.fCoontrolsFCP[codigoParametro].value);
    return date.valueOf();
  }

  /* verificar el campo en el que se esta haciendo focus */
  focusCampo(campo: string) {
    this.campoFormulario = campo;
  }

  /* habilitar o inhabilitar la PoliticaPlanteamientoPolitica */
  habilitarInhabilitarPoliticaPlanteamientoPolitica(
    row: PoliticaPlanteamientoPolitica
  ) {
    this.carTabla = true;
    this.centralizadaPoliticas.politicasPlanteamientosPoliticas.map((x) => {
      if (row.orden === x.orden) {
        x.indicadorHabilitado = x.indicadorHabilitado ? true : false;
      }
    });
    this.ordenarListaPoliticas();
    this.planteamientosEditado.emit(true);
    this.carTabla = false;
  }

  /* Hace match dependiendo del perfil escogido, este metodo no aplica como parametro,
  aplica siempre y cuando la politica de credito tenga el indicadorSegunPerfilRiesgo en 1 */
  async validarAplicaPerfilRiesgo() {
    this.aplica = false;
    if (this.centralizadaPoliticas.politica && this.centralizadaPoliticas.politica.indicadorPerfilRiesgo) {
      this.aplica = true;
    }
  }

  ordenarListaPoliticas() {
    let resultado = '';
    let _nCierres = 0;
    this.cantidadPatron = this.centralizadaPoliticas.politicasPlanteamientosPoliticas.filter( cp => cp.indicadorHabilitado);
    this.centralizadaPoliticas.politicasPlanteamientosPoliticas.forEach((value, key) => {
        const _anterior = this.cantidadPatron[key - 1];
        if (!_anterior) {
          resultado += `( ${value.orden} ${key === (this.cantidadPatron.length - 1 ) ? '' : value.tipoCondicional}`;
          _nCierres++;
        } else if (_anterior && _anterior.tipoCondicional !== value.tipoCondicional) {
          resultado += ` ( ${value.orden} ${key === (this.cantidadPatron.length - 1 ) ? '' : value.tipoCondicional}`;
          _nCierres++;
        } else {
          resultado += ` ${value.orden} ${key === (this.cantidadPatron.length - 1 ) ? '' : value.tipoCondicional}`;
        }
    });
    for (let index = 0; index < _nCierres; index++) {
      resultado += ' ) ';
    }
    this.centralizadaPoliticas.politica.ordenEjecucion = resultado;
  }

  async cambiarOrden( item: any, subir: boolean ) {
      const miIndice = this.centralizadaPoliticas.politicasPlanteamientosPoliticas.indexOf( item );
    /*if (item.orden <= 1 || item.orden > this.centralizadaPoliticas.politicasPlanteamientosPoliticas.length) {
      const posicion = (this.centralizadaPoliticas.politicasPlanteamientosPoliticas.length) - (item.orden === 1 ? 0 : item.orden < 1 ? item.orden * -1 : item.orden);
      const nueva = this.centralizadaPoliticas.politicasPlanteamientosPoliticas[ miIndice ];
      nueva.orden = posicion;
      const actualPosicion = this.centralizadaPoliticas.politicasPlanteamientosPoliticas.indexOf( item );
      this.centralizadaPoliticas.politicasPlanteamientosPoliticas.forEach( (v, k) => {
        if (!subir && v.orden >= nueva.orden && actualPosicion !== k) {
          v.orden += 1;
        } else if (subir && v.orden <= nueva.orden && actualPosicion !== k) {
          v.orden -= 1;
        }
      });
    } else*/
    if ( subir) {
        const nueva = this.centralizadaPoliticas.politicasPlanteamientosPoliticas[ miIndice ];
        nueva.orden = nueva.orden - 1;
        const actual = this.centralizadaPoliticas.politicasPlanteamientosPoliticas[ miIndice - 1 ];
        actual.orden = actual.orden + 1;
      } else {
        const nueva = this.centralizadaPoliticas.politicasPlanteamientosPoliticas[ miIndice ];
        nueva.orden = nueva.orden + 1;
        const actual = this.centralizadaPoliticas.politicasPlanteamientosPoliticas[ miIndice + 1 ];
        actual.orden = actual.orden - 1;
      }

    this.centralizadaPoliticas.politicasPlanteamientosPoliticas.sort( (a, b) => {
      if ( a.orden < b.orden ) {
        return -1;
      }
      if ( a.orden > b.orden ) {
        return 1;
      }
      return 0;
    });
  }
  eliminarPoliticaPlanteamientoPolitica(item: PoliticaPlanteamientoPolitica, posicion: number) {
    this.conServicio.confirm({
      header: this.navService.buscarMensaje('LBL_INFORMACION'),
      message: this.navService.buscarMensaje('POLITICAS.MSG_ELIMINAR'),
      key: 'eliminar',
      accept: () => {
        item.indicadorHabilitado = false;
        if (item.idPoliticaPlanteamientoPolitica) {
          this.centralizadaPoliticas.lisPoliticaPlanteaminetoEliminadas.push(item);
          this.actualizarPoliticaPlanteamientoPolitica.emit(this.centralizadaPoliticas);
            this.centralizadaPoliticas.politicasPlanteamientosPoliticas.splice(posicion, 1);
            this.centralizadaPoliticas.politicasPlanteamientosPoliticas.forEach( (v, k) => {
              if (item.orden < v.orden || posicion === 0) {
                v.orden  -= 1;
              }
            });
            this.ordenarListaPoliticas();
            this.actualizarPoliticaPlanteamientoPolitica.emit(this.centralizadaPoliticas);
            this.planteamientosEditado.emit(true);
        } else {
          this.centralizadaPoliticas.politicasPlanteamientosPoliticas.splice(posicion, 1);
          this.ordenarListaPoliticas();
          this.planteamientosEditado.emit(true);
        }
      },
      reject: () => {
      }
    });
  }

  actualizarOrden(event: boolean) {
    this.ordenar = event;
    this.ordenarListaPoliticas();
  }

  valorParametro(parametro: string) {
    if (parametro === this.parametrosPoliticas.PORCENTAJESALDOCANCELADO ) {
      return this.calcular(null, false, true);
    } else if (parametro === this.parametrosPoliticas.PORCENTAJECOBERTURA) {
      return this.calcularPorcentajeCobertura(parametro)
    } else if (parametro === this.parametrosPoliticas.MESESCUOTASPAGADAS ) {
      return this.calcularMeses(null, false, true) ;
    } else if (parametro === this.parametrosPoliticas.DESEMBOLSOFINANANCIERO ||
        parametro === this.parametrosPoliticas.DESEMBOLSOCOOPERATIVO ||
        parametro === this.parametrosPoliticas.DESEMBOLSOREAL ||
        parametro === this.parametrosPoliticas.FECHASOLICITUD ||
        parametro === this.parametrosPoliticas.COBROJURIDICOFINANCIERO ||
        parametro === this.parametrosPoliticas.COBROJURIDICOCOOPERATIVO ||
        parametro === this.parametrosPoliticas.COBROJURIDICOSECTORREAL ||
        parametro === this.parametrosPoliticas.FECHACIERRECOBROJURIDICO ||
        parametro === this.parametrosPoliticas.FECHAULTIMOCIERRECREDITOCREZCAMOS ||
        parametro === this.parametrosPoliticas.FECHAULTIMODESEMBOLSOCREZCAMOS ||
        parametro === this.parametrosPoliticas.DESEMBOLSOFINANANCIEROPASIVOMANUAL ||
        parametro === this.parametrosPoliticas.DESEMBOLSOCOOPERATIVOPASIVOMANUAL ||
        parametro === this.parametrosPoliticas.DESEMBOLSOREALPASIVOMANUAL ||
        parametro === this.parametrosPoliticas.FECHANACIMIENTOTER ||
        parametro === this.parametrosPoliticas.FECHAEXPEDICIONTER ||
        parametro === this.parametrosPoliticas.FECHAACT ||
        parametro === this.parametrosPoliticas.FECEXPTU
    ) {
      return this.obtenerMilisegundosFecha(parametro);
    } else if (parametro === this.parametrosPoliticas.ANIO) {
      return (365 * 86400000);
    } else if (parametro === this.parametrosPoliticas.MES) {
      return (30 * 86400000);
    } else if (parametro === this.parametrosPoliticas.SALARIO) {
      return this.codigoSalario.valor;
    } else if (
      parametro === this.parametrosPoliticas.VEOBVISEFI3 ||
      parametro === this.parametrosPoliticas.VEOBVISECO3 ||
      parametro === this.parametrosPoliticas.VEOBVISERE3 ||
      parametro === this.parametrosPoliticas.VEOBVISEREESP3
    ) {
      return this.fCoontrolsFCP[parametro].value;
    } else if (parametro === this.parametrosPoliticas.VIGENTEFINANCIERO ||
      parametro === this.parametrosPoliticas.VIGENTECOOPERATIVO ||
      parametro === this.parametrosPoliticas.CERRADASFINANCIERO ||
      parametro === this.parametrosPoliticas.CERRADASCOOPERATIVO ||
      parametro === this.parametrosPoliticas.CERRADASSECTORREAL ||
      parametro === this.parametrosPoliticas.VIGENTESECTORREAL ||
      parametro === this.parametrosPoliticas.OBLIGACIONESVIGENTESTELCOS ||
      parametro === this.parametrosPoliticas.OBLIGACIONVIGESPECIALIZADAREAL ||
      parametro === this.parametrosPoliticas.OBLIGACIONCERESPECIALIZADAREAL
    ) {
      let sumador = 0;
      const cadena = this.fCoontrolsFCP[parametro].value;
      const split = cadena.includes('|') ? cadena.split('|') : cadena.split('');
      split.slice(0, Number(this.codigoNum.valor)).forEach( value => {
          const valorMayus = Number(value) ? Number(value) : value.toUpperCase();
        if (valorMayus !== 'N' && value !== '-' && valorMayus !== 'R' && valorMayus !== 'X') {
            if (valorMayus === 'D') {
                sumador += 1;
            } else if (valorMayus === 'C') {
              sumador += 6;
            } else {
              if (value !== "") {
                sumador += cadena.includes('|') ? this.convertirValor(value) : Number(value);
              }
            }
          }
      });
      return sumador;
    } else if (parametro === this.parametrosPoliticas.RESTRUCTURADAFINANCIERO ||
      parametro === this.parametrosPoliticas.REESTRUCTURADACOOPERATIVO ||
      parametro === this.parametrosPoliticas.REESTRUCTURADAREAL ||
      parametro === this.parametrosPoliticas.OBLIGACIONESRESTRUCTURADASTELCOS ||
      parametro === this.parametrosPoliticas.RESTVIGESCPECIALIZADAREAL
    ) {
      let sumador = 0;
      const cadena = this.fCoontrolsFCP[parametro].value;
      const split = cadena.includes('|') ? cadena.split('|') : cadena.split('');
      split.slice(0, Number(this.codigoVer.valor)).forEach( value => {
        const valorMayus = Number(value) ? Number(value) : value.toUpperCase();
        if (valorMayus !== 'N' && value !== '-' && valorMayus !== 'R' && valorMayus !== 'X') {
          if (valorMayus === 'D') {
            sumador += 1;
          } else if (valorMayus === 'C') {
            sumador += 6;
          } else {
            if (value !== "") {
              sumador += cadena.includes('|') ? this.convertirValor(value) : Number(value);
            }
          }
        }
      });
      return sumador;
    } else if (parametro === this.parametrosPoliticas.OCUPACIONEMPLEADO) {
      if (this.codigoOcupEmp && this.codigoOcupEmp.idConstante) {
        const _codigoOcupacion = this.listaAdmOcupacionesTodos.find( l => l.idTipoOcupacionConfiguracion === this.fCoontrolsFCP[parametro].value);
        if (_codigoOcupacion) {
          const _buscar = this.codigoOcupEmp.valor.split(',').find(t => t === _codigoOcupacion.codigoTipoOcupacion);
          return _buscar ? 1 : 0;
        }
      }
      return 0;
    } else if (parametro === this.parametrosPoliticas.OCUPACIONPENSIONADO) {
      if (this.codigoOcupPen && this.codigoOcupPen.idConstante) {
        const _codigoOcupacion = this.listaAdmOcupacionesTodos.find( l => l.idTipoOcupacionConfiguracion === this.fCoontrolsFCP[parametro].value);
        if (_codigoOcupacion) {
          const _buscar = this.codigoOcupPen.valor.split(',').find(t => t === _codigoOcupacion.codigoTipoOcupacion);
          return _buscar ? 1 : 0;
        }
      }
      return 0;
    } else if (parametro === this.parametrosPoliticas.OBLIVIGENTESFINANCIERO ||
      parametro === this.parametrosPoliticas.OBLIVIGENTESCOOPERATIVO ||
      parametro === this.parametrosPoliticas.OBLIVIGENTEREAL ||
      parametro === this.parametrosPoliticas.OBLIGACIONESVIGENTESTELCOSDOS ||
      parametro === this.parametrosPoliticas.OBLIGACIONVIGESPECIALIZADAREAL2
    ) {
      let sumador = 0;
      const cadena = this.fCoontrolsFCP[parametro].value;
      const split = cadena.includes('|') ? cadena.split('|') : cadena.split('');
      split.slice(0, Number(this.codigoUltiVect.valor)).forEach( value => {
        const valorMayus = Number(value) ? Number(value) : value.toUpperCase();
        if (valorMayus !== 'N' && value !== '-' && valorMayus !== 'R' && valorMayus !== 'X') {
          if (valorMayus === 'D') {
            sumador += 1;
          } else if (valorMayus === 'C') {
            sumador += 6;
          } else {
            if (value !== "") {
              sumador += cadena.includes('|') ? this.convertirValor(value) : Number(value);
            }
          }
        }
      });
      return sumador;
    } else if (parametro === this.parametrosPoliticas.QUANTOVALORMEDIO ||
      parametro === this.parametrosPoliticas.NOVEDADRETIRO ||
      parametro === this.parametrosPoliticas.TERCEROASEGURABLE ||
      parametro === this.parametrosPoliticas.TALANSOCIOSARLAFT ||
      parametro === this.parametrosPoliticas.TALANSOCIOSARLAFTJURIDICO ||
      parametro === this.parametrosPoliticas.TALANSOCIOSLISTASRES ||
      parametro === this.parametrosPoliticas.TALANSOCIOSNOTAINTERNA ||
      parametro === this.parametrosPoliticas.TALANLISTASNEGRASDOCUMENTOS ||
      parametro === this.parametrosPoliticas.TALANLISTASNEGRASTELEFONOS ||
      parametro === this.parametrosPoliticas.TALANLISTASNEGRASCORREOS ||
      parametro === this.parametrosPoliticas.FIRPAG
    ) {
      return this.fCoontrolsFCP[parametro].value ? 1 : 0;
    } else if (parametro === this.parametrosPoliticas.ANAULTPAGOCOBJURIDICO ||
               parametro === this.parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECFIN ||
               parametro === this.parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECCOO ||
               parametro === this.parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECREL ) {
      let sumador = 0;
      const cadena = this.fCoontrolsFCP[parametro].value;
      const split = cadena.includes('|') ? cadena.split('|') : cadena.split('');
      split.slice(0, Number( 1 )).forEach( value => {
        const valorMayus = Number(value) ? Number(value) : value.toUpperCase();
        if (valorMayus !== 'N' && value !== '-' && valorMayus !== 'R' && valorMayus !== 'X') {
          if (valorMayus === 'D') {
            sumador += 1;
          } else if (valorMayus === 'C') {
            sumador += 6;
          } else {
            if (value !== "") {
              sumador += cadena.includes('|') ? this.convertirValor(value) : Number(value);
            }
          }
        }
      });
      return sumador;
    } else if (parametro === this.parametrosPoliticas.TIPODOCUMENTOVERIFICAR) {
      if (this.codigoTidove && this.codigoTidove.indicadorHabilitado) {
        const cadena = this.fCoontrolsFCP[parametro].value;
        const buscar = this.codigoTidove.valor.toUpperCase().split(",");
        return !!buscar.find(x => x === cadena) ? 1: 0;
      } else {
        return null;
      }
    } else if (parametro === this.parametrosPoliticas.PATRITECN){
      return (this.constantePattec?.indicadorHabilitado && this.constantePattec?.valor && !isNaN(Number(this.constantePattec.valor))) ? Number(this.constantePattec.valor) : 0;
    }
    else {
      return this.fCoontrolsFCP[parametro].value;
    }
  }

  convertirValor(input: string) {
    const valores: { [key: string]: number } = { C: 6, D: 1 };
    let resultado = '';

    if (!isNaN(Number(input))) {
      return Number(input);
    }

    for (const caracter of input) {
      const caracterMayuscula = caracter.toUpperCase();

      if (caracterMayuscula in valores) {
        resultado += valores[caracterMayuscula];
      } else if (!isNaN(Number(caracterMayuscula))) {
        resultado += caracterMayuscula;
      }
    }

    return Number(resultado);
  }

  calcular (event?: any, valor?: boolean, guardar: boolean = false) {
    if ((this.porcetajeCancelado !== 0 || this.porcetajeCancelado !== null) && guardar ) {
      this.montoDesembolsado = 0;
      this.saldoCapital = 0;
      return this.porcetajeCancelado;
    }
    this.porcetajeCancelado = 0;
    valor ? this.saldoCapital = parseInt(event.substr(1).replace(/(,)/gm,"")) : this.montoDesembolsado = parseInt(event.substr(1).replace(/(,)/gm,""));
    if ( this.saldoCapital > 0 && this.montoDesembolsado > 0 ){
      this.porcetajeCancelado = ( this.saldoCapital / this.montoDesembolsado ) * 100;
    }
  }

  calcularPorcentajeCobertura(codigoParametro: string) {
    const montoCobertura = this.fCoontrolsFCP['montoCobertura'].value;
    const montoSolicitud = this.fCoontrolsFCP['montoSolicitud'].value;
    if(( montoCobertura && montoCobertura > 0 ) && ( montoSolicitud && montoSolicitud > 0 )) {
      this.porcentajeCobertura = (montoCobertura / montoSolicitud * 100);
    } else {
      this.porcentajeCobertura = null;
    }
    this.fCoontrolsFCP[codigoParametro].setValue(this.porcentajeCobertura);
    return this.fCoontrolsFCP[codigoParametro].value;
  }

  calcularMeses(event?: any, valor?: boolean, guardar: boolean = false) {
    if (this.mesesCuotas !== null && guardar) {
      return this.mesesCuotas;
    }
    valor ? this.cuotas = event : this.frecuencia = event;
    const obtFrecuencia = this.obtenerFrecuencia( this.frecuencia );
    if ( obtFrecuencia && this.cuotas && obtFrecuencia.codigo !== 'Y30' && obtFrecuencia.codigo.length > 1 ) {
      const diaFrecuencia = obtFrecuencia.codigo.substring( 1 );
      this.mesesCuotas = ( (diaFrecuencia !== null ) ? (Number(this.cuotas) * (Number(diaFrecuencia) / 30)) : null );
    } else {
      this.mesesCuotas = null;
    }
  }

  calcularFirmas(codigoParametro: string) {
    let casadoConyuge = ["CAS", "MASDVI", "MENOSDVI"];
    let casdinRelacionados = ["CAEXDOIN", "CACONM", "CASDIN"];
    let noConyuge = ["NA", "SEPADI", "SOL", "VIUDO"];

    const estadoCivilInicial = this.fCoontrolsFCP['estadoInicial'].value;
    const estadoCivilFinal = this.fCoontrolsFCP['estadoFinal'].value;
    const estadoConyuge = this.fCoontrolsFCP['estadoConyuge'].value;
    const radioButton = this.fCoontrolsFCP['conyuge'].value;

    switch (radioButton) {
      case this.estadoConyuge.DIFERENTE:
        if( !estadoCivilInicial || !estadoCivilFinal || !estadoConyuge ) return
        if (casadoConyuge.includes(estadoCivilInicial) && casadoConyuge.includes(estadoCivilFinal)) {
          return this.fCoontrolsFCP[codigoParametro].setValue(0);
        }else if(casdinRelacionados.includes(estadoCivilInicial) && casadoConyuge.includes(estadoCivilFinal)){
            return this.fCoontrolsFCP[codigoParametro].setValue(0);
        }else{
          break;
        }
      case this.estadoConyuge.IGUAL:
        if( !estadoCivilInicial || !estadoCivilFinal || !estadoConyuge ) return
        if (casadoConyuge.includes(estadoCivilInicial) && casadoConyuge.includes(estadoCivilFinal)) {
          if( estadoConyuge === 'UNFVIG') {
            return this.fCoontrolsFCP[codigoParametro].setValue(1);
          }else{
            return this.fCoontrolsFCP[codigoParametro].setValue(0);
          }
        }else if(casdinRelacionados.includes(estadoCivilInicial) && casadoConyuge.includes(estadoCivilFinal)){
          if( estadoConyuge === 'UNFVIG') {
            return this.fCoontrolsFCP[codigoParametro].setValue(1);
          }else{
            return this.fCoontrolsFCP[codigoParametro].setValue(0);
          }
        }else{
          break;
        }
      case this.estadoConyuge.NOAPLICA:
        if( !estadoCivilInicial || !estadoCivilFinal ) return
        if (casadoConyuge.includes(estadoCivilInicial) && noConyuge.includes(estadoCivilFinal)) {
          return this.fCoontrolsFCP[codigoParametro].setValue(0);
        }else{
          return this.fCoontrolsFCP[codigoParametro].setValue(1);
        }
    }
  }

  limitarNumero(input: HTMLInputElement, codigoParametro: string): void {
    if (codigoParametro === this.parametrosPoliticas.TOTALLIQUIDEZCUBIERTA) {
      const numStr = input.value.replace(/\D/g, '');
      if ( !numStr ) {
        input.value = '';
      } else {
        let num = parseInt(numStr, 10); // Convertir a número entero

        // Limitar el número a 100 si es mayor
        if (num > 100) {
          num = 100;
        }

        // Asignar el valor al input
        input.value = num.toString();
      }
    }
  }

  addInputCreditosAntiguos(): void {
    if (this.inputsCreditosAntiguos.length < 10) {
      this.inputsCreditosAntiguos.push({ value: '', tipoVinculacion: '' });
      this.formularioComprobarPolitica.addControl('tipoVinculacion' + (this.inputsCreditosAntiguos.length - 1), this.fb.control('',[] ));
    }
  }

  addInputCreditosNuevos(): void {
    if (this.inputsCreditosNuevos.length < 10) {
      this.inputsCreditosNuevos.push({ value: '', tipoVinculacion: '' });
      this.formularioComprobarPolitica.addControl('tipoVinculacionNuevo' + (this.inputsCreditosNuevos.length - 1), this.fb.control('',[] ));
    }
  }

  removeInput(index: number, type: 'inputsCreditosAntiguos' | 'inputsCreditosNuevos', codigoParametro: string): void {
    if (type === 'inputsCreditosAntiguos') {
      this.inputsCreditosAntiguos.splice(index, 1);
      this.fCoontrolsFCP['tipoVinculacion' + index].setValue(null);
    } else if (type === 'inputsCreditosNuevos') {
      this.inputsCreditosNuevos.splice(index, 1);
      this.fCoontrolsFCP['tipoVinculacionNuevo' + index].setValue(null);
    }
    this.verificarDuplicados(codigoParametro);
  }

  onKeyPress(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onInputChange(event: Event, inputArray: { value: string, tipoVinculacion: string }[], currentIndex: number) {
    let input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^\d]/g, '');
    if (input.value.length > 30) {
      input.value = input.value.slice(0, 30);
    }
  }

  validarVentaCruzada(event: Event, inputArray: { value: string, tipoVinculacion: string }[], codigoParametro: string, index: number) {
    let input = event.target as HTMLInputElement;
    if (!input.value) return;
    const valorDuplicado = inputArray.some((item, i) => item.value === input.value && i !== index);

    if (valorDuplicado) {
      // Mostrar mensaje de error o limpiar el valor duplicado
      input.value = '';
      this.showMessage("LBL_INFORMACION", "PLANTILLA.MSG_ERRORCEDULA");
    } else {
      inputArray[index].value = input.value;
    }

    this.verificarDuplicados(codigoParametro);
  }

  validarVentaCruzadaVinculacion(event: any, inputArray: { value: string, tipoVinculacion: string }[], codigoParametro: string, index: number) {
    let input = event;
    if (!input.value) return;
    inputArray[index].tipoVinculacion = input.value;
    this.verificarDuplicados(codigoParametro);
  }

  checkFields() {
    this.errorIndicesAntiguos = [];
    this.errorIndicesNuevos = [];

    // Verifica los inputs antiguos
    this.errorIndicesAntiguos = this.inputsCreditosAntiguos
      .map((input, index) => (!input.value || !input.tipoVinculacion) ? index : -1)
      .filter(index => index !== -1);

    // Verifica los inputs nuevos
    this.errorIndicesNuevos = this.inputsCreditosNuevos
      .map((input, index) => (!input.value || !input.tipoVinculacion) ? index : -1)
      .filter(index => index !== -1);
  }

  handleButtonClick() {
    const validarParametro = !!this.lisParametrosAgregados.find( parametro => parametro.codigoParametro === this.parametrosPoliticas.VENTACRUZADA );
    if( validarParametro ) {
      this.checkFields();
     }
  }

  // Filtra las opciones del dropdown para eliminar "Titular" si ya fue seleccionada
  getFilteredVinculacionesNuevas(inputsCreditosNuevos: { value: string, tipoVinculacion: string }[], currentIndex: number) {
    // Filtrar las opciones: Si "Titular" ya fue seleccionada, la eliminamos de la lista
    return this.listaTiposVinculacionesCruzada.filter(option => {
      if (option.value === 'TITULAR' && currentIndex !== 0) {
        return false
      } else {
        return true
      };
    });
  }
  getFilteredVinculacionesAntiguas(inputsCreditosAntiguos: { value: string, tipoVinculacion: string }[], currentIndex: number) {
    // Filtrar las opciones: Si "Titular" ya fue seleccionada, la eliminamos de la lista
    return this.listaTiposVinculacionesCruzada.filter(option => {
      if (option.value === 'TITULAR' && currentIndex !== 0) {
        return false
      } else {
        return true
      };
    });
  }
  verificarDuplicados(codigoParametro: string) {
    const vinculacionesValidas = ['TITULAR', 'CODDEU', 'DEUSO'];
    const equivalenciasVinculacion = ['CODDEU', 'DEUSO'];

    const documentosAntiguos = this.inputsCreditosAntiguos.map(input => ({
      value: input.value.trim(),
      tipoVinculacion: input.tipoVinculacion.trim(),
    }));

    const documentosNuevos = this.inputsCreditosNuevos.map(input => ({
      value: input.value.trim(),
      tipoVinculacion: input.tipoVinculacion.trim(),
    }));

    // Filtrar los documentos nuevos que tengan coincidencias en documentos antiguos
    const coincidencias = documentosNuevos.filter(docNuevo =>
      documentosAntiguos.some(docAnt => docAnt.value === docNuevo.value)
    );

    // Si no hay al menos dos coincidencias, retornar 0
    if (coincidencias.length < 2) {
      return this.fCoontrolsFCP[codigoParametro].setValue(0);
    }

    // Revisar las vinculaciones de los documentos que tienen coincidencias
    for (let docNuevo of coincidencias) {
      const docAntiguo = documentosAntiguos.find(docAnt => docAnt.value === docNuevo.value);

      if (docAntiguo) {
        // Si la vinculación antigua no es válida, continuar
        if (!vinculacionesValidas.includes(docAntiguo.tipoVinculacion)) {
          continue;
        }

        // Si las vinculaciones son equivalentes o iguales, devuelvo 0
        if (
          (equivalenciasVinculacion.includes(docAntiguo.tipoVinculacion) &&
            equivalenciasVinculacion.includes(docNuevo.tipoVinculacion)) ||
          docAntiguo.tipoVinculacion === docNuevo.tipoVinculacion
        ) {
          return this.fCoontrolsFCP[codigoParametro].setValue(0);
        }

        // Si las vinculaciones son diferentes, devuelvo 1
        return this.fCoontrolsFCP[codigoParametro].setValue(1);
      }
    }

    // Si no hay vinculaciones equivalentes o iguales, devuelvo 0 por defecto
    return this.fCoontrolsFCP[codigoParametro].setValue(0);
  }





  onDateSelect(event: any, codigoParametro: string): void {
    const selectedDate = new Date(event);
    this.diferenciaMeses = this.calculateDateDifferenceInMonths(this.fechaDeHoy, selectedDate);
    return this.fCoontrolsFCP[codigoParametro].setValue(this.diferenciaMeses);
  }

  calculateDateDifferenceInMonths(date1: Date, date2: Date): number {
    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    let monthsDifference = endDate.getMonth() - startDate.getMonth();
    let totalMonthsDifference = (yearsDifference * 12) + monthsDifference;

    const daysInStartMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();
    const daysInEndMonth = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate();

    const startMonthFraction = (daysInStartMonth - startDate.getDate() + 1) / daysInStartMonth;
    const endMonthFraction = endDate.getDate() / daysInEndMonth;

    let totalMonthsWithFractions = totalMonthsDifference + startMonthFraction + endMonthFraction - 1;
    return parseFloat(totalMonthsWithFractions.toFixed(2));
  }

  get fechaDeHoyFormatted(): string {
    return this.datePipe.transform(this.fechaDeHoy, 'yyyy-MM-dd') || '';
  }

  calcularEdadTercero( value: string, codigoParametro: string ) {
    if ( value === "0" ) {
      this.edadTerceroMeses = 0;
      this.fCoontrolsFCP[codigoParametro].setValue(this.edadTerceroMeses)
      return
    }
    this.edadTerceroMeses = +value * 12;
    this.fCoontrolsFCP[codigoParametro].setValue(this.edadTerceroMeses)
  }

  cambioVinvulacion(vinculacion: string, valor: any) {
    if (vinculacion === 'vinculacion1') {
      this.vinculacion1 = valor;
    } else if (vinculacion === 'vinculacion2') {
      this.vinculacion2 = valor;
    }
    this.vinculacionesIguales = this.vinculacion1 === this.vinculacion2;
    const resultado = this.vinculacionesIguales ? 0 : 1;
    this.fCoontrolsFCP[this.parametrosPoliticas.CAMBIODEVINCULACION].setValue(resultado)
  }

  validarVinculacionesRespaldos( event: any ) {
    this.vinculacionesRespaldos = event
    const resultado = this.vinculacionesRespaldos ? 1 : 0;
    this.fCoontrolsFCP[this.parametrosPoliticas.VINVULACIONRESPALDOS].setValue(resultado);
  }

  calcularUltimaOcupacion(codigoParametro: string): void {
    const anterior = this.fCoontrolsFCP['ocupacionAnterior'].value;
    const actual   = this.fCoontrolsFCP['ocupacionActual'].value;
    if (!actual) {
      this.fCoontrolsFCP[codigoParametro].setValue(null);
      return;
    }
    if (!anterior) {
      // Cliente sin solicitudes en estado final → conserva ocupación
      this.fCoontrolsFCP[codigoParametro].setValue(1);
      return;
    }
    this.fCoontrolsFCP[codigoParametro].setValue(anterior === actual ? 1 : 0);
  }


  calcularUltimaActividadEconomica(codigoParametro: string): void {
    const anterior = this.fCoontrolsFCP['actividadEconomicaAnterior'].value;
    const actual   = this.fCoontrolsFCP['actividadEconomicaActual'].value;

    if (!anterior && !actual) {
      this.fCoontrolsFCP[codigoParametro].setValue(1);
      return;
    }

    if (anterior === null && actual === null) {
      this.fCoontrolsFCP[codigoParametro].setValue(1);
      return;
    }

    if ((!anterior && actual) || (anterior && !actual)) {
      this.fCoontrolsFCP[codigoParametro].setValue(0);
      return;
    }

    this.fCoontrolsFCP[codigoParametro].setValue(anterior === actual ? 1 : 0);
  }

  calcularGarantiaIdonea(codigoParametro: string): void {
    const tipoGarantia = this.fCoontrolsFCP['tipoGarantiaGaridon'].value;
    if (!tipoGarantia) {
      this.fCoontrolsFCP[codigoParametro].setValue(0);
      return;
    }
    const esIdonea = tipoGarantia === 'I' || tipoGarantia === 'F';
    this.fCoontrolsFCP[codigoParametro].setValue(esIdonea ? 1 : 0);
  }

  private showMessage(
    titulo: string,
    mensaje: string,
    severity: string = "info"
  ) {
    this.navService.setMesage(0, {
      severity: severity,
      summary: this.navService.buscarMensaje(titulo),
      detail: this.navService.buscarMensaje(mensaje),
    });
  }

  calcularValorNivel(codigoParametro: string) {
    const inputUsuario = this.fCoontrolsFCP.nivelRiesgoEmpleador.value?.toLowerCase().trim();
    const mappings: Record<string, string> = {};

    this.constanteNivrem.valor.split(',').forEach(pair => {
      const [keyRaw, valueRaw] = pair.split('=');
      const key = keyRaw.replace(/["“”]/g, '').toLowerCase().trim();
      const value = valueRaw.trim();
      mappings[key] = value;
    });

    this.fCoontrolsFCP[codigoParametro].setValue(
      mappings.hasOwnProperty(inputUsuario) ? mappings[inputUsuario] : ''
    );
  }

  calcularContinuidadLaboral(codigoParametro: string) {
    const binario = this.fCoontrolsFCP.vector.value || '';
    const binarioFiltrado = binario.replace(/[^01]/g, '');
    this.fCoontrolsFCP.vector.setValue(binarioFiltrado, { emitEvent: false });
    if (!binarioFiltrado) {
      this.fCoontrolsFCP[codigoParametro].setValue(null);
      return;
    }
    const ocupacion = this.fCoontrolsFCP.ocupacion.value;
    if (!ocupacion) {
      this.fCoontrolsFCP[codigoParametro].setValue(null);
      return;
    }
    const inicio = Number(this.constanteMeinco.valor) || 0;
    const subcadena = binarioFiltrado.substring(inicio);
    const resultado = subcadena.includes('0') ? 0 : 1;
    this.fCoontrolsFCP[codigoParametro].setValue(resultado);
    console.log(resultado, 'resultado');
  }

  validarEndeudamientoInternoSocios(codigoParametro: string) {
  /// para que sea verdadero el porcentaje no debe superar el valor de la contante y debe tener valor endeudamiento
    const porcentajeParticipacion = this.fCoontrolsFCP['porcentajeParticipacion'].value;
    const valorEndeudamiento   = this.fCoontrolsFCP['valorEndeudamiento'].value;
    console.log(porcentajeParticipacion, valorEndeudamiento);
    if (porcentajeParticipacion > 0 && valorEndeudamiento) {
      const valores = this.constanteParacc.valor.split(",");
      const maximo = valores.length > 1 ? Number(valores[1]) : null;
      if (porcentajeParticipacion >= maximo) {
        this.fCoontrolsFCP[codigoParametro].setValue(valorEndeudamiento);
      }else {
        this.fCoontrolsFCP[codigoParametro].setValue(0);
      }
    }else {
      this.fCoontrolsFCP[codigoParametro].setValue(0);

    }

  }

  limitarRango(codigoParametro: string) {
    const control = this.fCoontrolsFCP[codigoParametro];
    if (!control) return;

    const valor = parseInt(control.value, 10);
    if (isNaN(valor)) return;

    if (valor < -999) control.setValue(-999);
    else if (valor > 999) control.setValue(999);
  }

  protected readonly Number = Number;
}
